import { useEffect, useState } from "react";
import { useGlobalContext } from "../../Context/Authentation";
import SearchsingleNotes from "../../Components/Notes/SearchsingleNotes.jsx";
import Lottie from "react-lottie";
import noNotesanimation from '../../Animations/no notes.json'
import { useNavigate } from "react-router-dom";

export default function SearchPage() {
    const navigate = useNavigate();
    const { setUpdateModalcontent, setUpdateModalTitle, setNoteId, setDeleteModalTitle, searchNoteArray, refresh, SearchKeyword } = useGlobalContext();
    const [searchresult, setsearchresult] = useState([]);

    useEffect(() => {
        setsearchresult(searchNoteArray)
        // eslint-disable-next-line 
    }, [searchNoteArray, refresh])

    const defaultOptions = {
        loop: false,
        autoplay: true,
        animationData: noNotesanimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    }

    return (
        <div>
            <div style={{ display: "flex", alignItems: 'center', justifyContent: "start", flexWrap: "wrap" }}>

                <button className="btn btn-outline-primary mx-3" onClick={() => {
                    navigate('/Home/allNotes')
                }}><i class="bi bi-arrow-left"></i>  Back</button> <span className="mx-3 text" style={{ fontSize: "20px" }}>Search Result for
                    - &nbsp;<span style={{ fontSize: "23px", fontWeight: "700" }}>{SearchKeyword}</span>
                </span>

            </div>

            <>
                {searchresult?.length !== 0 ? (
                    <div className='layout grid' id='NotesContainer' >
                        {
                            searchresult?.map((e, index) => {
                                const DeleteclickHndler = () => {
                                    setDeleteModalTitle(e?.title)
                                    setNoteId(e?._id)
                                }
                                const UpdateclickHndler = () => {
                                    setUpdateModalTitle(e?.title)
                                    setUpdateModalcontent(e?.content)
                                    setNoteId(e?._id)
                                }
                                return (
                                    <div className='notewrapper' key={index} style={{ order: "1", }}>
                                        <SearchsingleNotes index={index} event={e} UpdateclickHndler={UpdateclickHndler}
                                            DeleteclickHndler={DeleteclickHndler} id={e._id}
                                        />
                                    </div>)
                            })
                        }
                    </div>
                ) : (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <Lottie options={defaultOptions}
                            width={"90%"}
                            height={"fit - content"}
                            style={{ marginTop: "auto", width: "400px", opacity: "0.6" }}
                        />
                        <h3>No notes found</h3>
                    </div>)}
            </>

        </div>
    )
}
